var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shadow.show)?_c('transition',{attrs:{"name":_vm.shadow.type},on:{"afterEnter":_vm.shadowLeave}},[_c('div',{staticClass:"test-main test-shadow",domProps:{"innerHTML":_vm._s(_vm.shadow.html)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32284856","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/question-single/src/testShadow.vue
// module id = 227
// module chunks = 0